/**
 * Utility function that enables cross-browser support for JavaScript's 'includes' method
 */
if (!String.prototype.includes) {
    String.prototype.includes = function() {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

/**
 * Utility function that verifies if email is valid
 */
function isEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}

/**
 * Utility function that extracts domain from url
 */
function extractDomain(url) {

	var domain;
	// find & remove protocol (http, ftp, etc.) and get domain
	if (url.indexOf("://") > -1) {
		domain = url.split('/')[2];
	} else {
		domain = url.split('/')[0];
	}
	// find & remove port number
	domain = domain.split(':')[0];
	return domain;

}

/**
 * Utility function that returns whether a link is external
 */
function isExternalLink(link_element) {
    return (link_element.host !== window.location.host);
}

/**
 * Utility function that verifies if TagCommander function is defined before calling it
 */
function sendEvent(eventName, eventParams){
	if(typeof tc_event !== 'undefined' && typeof tc_event === "function"){
		tc_event(eventName, eventParams);
	}else{
		console.info("Unable to call TagCommander's event forwarder. Check whether TagCommander is properly loaded.");
	}
	console.log(eventName, eventParams);
}

/**
 * Utility function that gets the event property value from the DOM for clickNavigation event
 */
function getClickNavigationPropertyValue(element, attribute){
	return element.siblings("[" + attribute +"]").attr(attribute);
}

/**
 * Utility function that gets the event property value from the DOM
 */
function getPropertyValue(element, attribute){
	return element.attr(attribute);
}

/**
 * Utility function that checks if a valid data-analytic attribute exists for clickNavigationEvent
 */
function clickNavigationSiblingExists(element, attribute){
	return element.siblings("[" + attribute +"]").length > 0;
}

/**
 * Utility function that checks if a valid data-analytic attribute exists
 */
function propertyExists(element, attribute){
	var attr = $(this).attr('name');
	return typeof attr !== typeof undefined && attr !== false;
}

/**
 * Utility function that checks if we're not in a certain page
 */
function isNotPage(pageID){
	return !$("body").attr("class").includes("page-"+pageID);
}

/**
 * Utility function that demonstrates event
 */
function demoEvent(eventName, eventParams) {
  console.log('%c' + eventName, 'background: #222; color: #fff; font-weight: 700');
  JSONstringify(eventParams);
}

/**
 * Utility function that pretty prints JSON
 */
function JSONstringify(json) {
  if (typeof json !== 'string') {
    json = JSON.stringify(json, undefined, '\t');
  }

  var
    arr = [],
    _string = 'color:green',
    _number = 'color:darkorange',
    _boolean = 'color:blue',
    _null = 'color:magenta',
    _key = 'color:red';

  json = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var style = _number;
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        style = _key;
      } else {
        style = _string;
      }
    } else if (/true|false/.test(match)) {
      style = _boolean;
    } else if (/null/.test(match)) {
      style = _null;
    }
    arr.push(style);
    arr.push('');
    return '%c' + match + '%c';
  });

  arr.unshift(json);

  console.log.apply(console, arr);
}

/**
 * Utility function that capitalize a string value
 */
function _capitalize(string) {
  return string.trim().toLowerCase().replace(/\w\S*/g, function (w) {
    return w.replace(/^\w/, function (c) {
      return c.toUpperCase();
    });
  });
}
